import { render } from "./VirtualMeetingMeetAppLive.vue?vue&type=template&id=48e450df&scoped=true&ts=true"
import script from "./VirtualMeetingMeetAppLive.vue?vue&type=script&lang=ts"
export * from "./VirtualMeetingMeetAppLive.vue?vue&type=script&lang=ts"

import "./VirtualMeetingMeetAppLive.vue?vue&type=style&index=0&id=48e450df&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e450df"]])

export default __exports__